import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue'
import VuePageTitle from 'vue-page-title'
import {authGuard} from '@/auth/authGuard'
import localStorageHelper from '@/helpers/localStorageHelper'
import i18n from '@/i18n'
Vue.use(VueRouter)
let lang = 'en' // default language

if (i18n && i18n.locale)
{
  const path = window.location.pathname // this.$route.path
// console.log(path)
  if (path.includes('/et/') || path === '/et') {
    i18n.locale = 'ee'
    localStorage.setItem('lang', 'ee')
  }
  if (path.includes('/en/') || path === '/en') {
    i18n.locale = 'gb'
    localStorage.setItem('lang', 'gb')
  }
  if (path.includes('/de/') || path === '/de') {
    i18n.locale = 'de'
    localStorage.setItem('lang', 'de')
  }
  if (path.includes('/es/') || path === '/es') {
    i18n.locale = 'es'
    localStorage.setItem('lang', 'es')
  }

  switch (i18n.locale)
  {
    case 'gb' :
      lang = 'en'
      break
    case 'ee' :
      lang = 'et'
      break
    case 'de' :
      lang = 'de'
      break
    case 'es' :
      lang = 'es'
      break
  }
}

// English (default version)
const defaultRoutes = [
  {
    path: '/cookie',
    name: 'Cookie',
    component: () => import('../views/Cookie'),
    meta: {
      title: 'Cookie Policy',
      description: 'We use only good cookies to make our websites more user-friendly. Find out about which type of cookies are being used and what we use them for.'
    }
  },
  {
    path: '/register',
    name: 'Get Started',
    component: () => import('../views/auth/Register-new.vue'),
    meta: {
      type: 'auth'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/auth/Login-new.vue'),
    meta: {
      type: 'auth'
    }
    // beforeEnter: authGuard
  },
  {
    path: '/reset-password',
    name: 'Reset password',
    component: () => import('../views/auth/Reset-password.vue'),
    meta: {
      type: 'auth'
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('../views/Logout'),
    meta: {
      title: i18n.t('router.logout.title'),
      description: i18n.t('router.logout.description')
    }
  },
  {
    path: i18n.t('router.links.registerComplete'),
    name: 'Complete registration',
    component: () => import('../views/Register.vue'),
    meta: {
      title: i18n.t('router.registerComplete.title'),
      description: i18n.t('router.registerComplete.description')
    },
    beforeEnter: authGuard
  },
  {
    path: i18n.t('router.links.account'),
    name: 'Account',
    component: () => import('../views/Account.vue'),
    meta: {
      title: i18n.t('router.account.title'),
      description: i18n.t('router.account.description')
    },
    beforeEnter: authGuard
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/Settings.vue'),
    meta: {
      title: i18n.t('router.settings.title'),
      description: i18n.t('router.settings.description')
    },
    beforeEnter: authGuard
  },
  {
    path: '/login-callback',
    name: 'login-callback',
    component: () => import('../views/Login-callback.vue'),
    meta: {
      title: 'Login in process...',
      description: 'Login in process...'
    }
  },
  {
    path: '/investments',
    name: 'Investments',
    component: () => import('../views/Investments.vue'),
    meta: {
      title: 'Investments',
      description: 'Investments',
      et: 'investeeringud'
    },
    beforeEnter: authGuard
  },
  {
    path: '/invest',
    name: 'Invest',
    component: () => import('../views/Invest.vue'),
    meta: {
      title: 'Invest',
      description: 'Invest',
      et: 'investeeri'
    },
    beforeEnter: authGuard
  },
  {
    path: '/strategy/create',
    name: 'create-strategy',
    component: () => import('../views/CreateAutoInvest'),
    meta: {
      title: 'Create new strategy',
      description: 'Create new strategy',
      et: 'strateegiad/loo'
    },
    beforeEnter: authGuard
  },
  {
    path: '/strategy/:id',
    name: 'strategy',
    component: () => import('../views/CreateAutoInvest'),
    meta: {
      title: 'Edit strategy details',
      description: 'Edit strategy details',
      et: 'strateegiad/:id'
    },
    beforeEnter: authGuard
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: () => import('../views/Withdraw.vue'),
    meta: {
      title: 'Withdraw',
      description: 'Withdraw',
      et: 'valjamakse'
    },
    beforeEnter: authGuard
  },
  {
    path: '/deposit',
    name: 'Deposit',
    component: () => import('../views/Deposit.vue'),
    meta: {
      title: 'Deposit',
      description: 'Deposit',
      et: 'deposiit'
    },
    beforeEnter: authGuard
  },
  {
    path: '/confirm-investment',
    name: 'Confirm investment',
    component: () => import('../views/Confirm-investment.vue'),
    meta: {
      title: 'Confirm investment',
      description: 'Confirm investment',
      et: 'kinnita-investeering'
    },
    beforeEnter: authGuard
  },
  {
    path: '/loan/:id',
    name: 'Loan details',
    component: () => import('../views/Loan-details.vue'),
    meta: {
      title: 'Loan details',
      description: 'Loan details',
      et: 'laen/:id'
    },
    beforeEnter: authGuard
  },
  {
    path: '/payment-schedule-details/:id',
    name: 'Payment schedule details',
    component: () => import('../views/Payment-schedule-details.vue'),
    meta: {
      title: 'Payment schedule details',
      description: 'Payment schedule details',
      et: 'maksegraafik/:id'
    },
    beforeEnter: authGuard
  },
  {
    path: '/notification-settings/:id/:hash',
    name: 'Notification settings',
    component: () => import('../views/Notification-settings.vue'),
    meta: {
      title: 'Notification settings',
      description: 'Notification settings'
    }
  },
  {
    path: '/404',
    name: 'PageNotFound',
    component: () => import('../views/PageNotFound'),
    meta: {
      title: 'Page not found'
      }
    }
]

let langRoutes = []
let defaultEngRoutes = []
if (lang !== 'en')
{
// Additional language routes
  langRoutes = [
    {
      path: '/' + lang + '/register',
      name: 'Get Started',
      component: () => import('../views/auth/Register-new.vue'),
      meta: {
        type: 'auth'
      }
    },
    {
      path: '/' + i18n.t('router.links.loanOriginators'),
      redirect: '/' + lang + '/' + i18n.t('router.links.loanOriginators')
    },
    {
      path: '/' + i18n.t('router.links.verifyEmail'),
      redirect: '/' + lang + '/' + i18n.t('router.links.verifyEmail')
    },
    {
      path: '/' + i18n.t('router.links.howItWorks'),
      redirect: '/' + lang + '/' + i18n.t('router.links.howItWorks')
    },
    {
      path: '/' + i18n.t('router.links.security'),
      redirect: '/' + lang + '/' + i18n.t('router.links.security')
    },
    {
      path: '/' + i18n.t('router.links.risk'),
      redirect: '/' + lang + '/' + i18n.t('router.links.risk')
    },
    {
      path: '/' + i18n.t('router.links.joinLoanOriginators'),
      redirect: '/' + lang + '/' + i18n.t('router.links.joinLoanOriginators')
    },
    {
      path: '/' + i18n.t('router.links.statistics'),
      redirect: '/' + lang + '/' + i18n.t('router.links.statistics')
    },
    {
      path: '/' + i18n.t('router.links.affiliate'),
      redirect: '/' + lang + '/' + i18n.t('router.links.affiliate')
    },
    {
      path: '/' + i18n.t('router.links.team'),
      redirect: '/' + lang + '/' + i18n.t('router.links.team')
    },
    {
      path: '/' + i18n.t('router.links.help'),
      redirect: '/' + lang + '/' + i18n.t('router.links.help')
    },
    {
      path: '/' + i18n.t('router.links.invite'),
      redirect: '/' + lang + '/' + i18n.t('router.links.invite')
    },
    {
      path: '/' + i18n.t('router.links.privacy'),
      redirect: '/' + lang + '/' + i18n.t('router.links.privacy')
    },
    {
      path: '/' + i18n.t('router.links.useragreement'),
      redirect: '/' + lang + '/' + i18n.t('router.links.useragreement')
    },
    {
      path: '/' + lang + i18n.t('router.links.registerComplete'),
      redirect: i18n.t('router.links.registerComplete')
    },
    {
      path: '/contest',
      name: 'Konkurss',
      component: () => import('../views/Contest'),
      meta: {
        title: 'Contest',
        description: ''
      }
    },
    {
      path: '/:lang',
      component: Main,
      meta:
        {
          title: i18n.t('router.home.title'),
          description: i18n.t('router.home.description')
        },
      children:
        [
          {
            path: '/',
            name: 'Home',
            component: () => import('../views/Home'),
            meta:
              {
                title: i18n.t('router.home.title'),
                description: i18n.t('router.home.description')
              }
          },
          {
            path: i18n.t('router.links.howItWorks'),
            name: 'How it works',
            component: () => import('../views/How-it-works'),
            meta:
              {
                title: i18n.t('router.hiw.title'),
                description: i18n.t('router.hiw.description'),
                key: 'howItWorks'
              }
          },
          {
            path: i18n.t('router.links.security'),
            name: 'Security',
            component: () => import('../views/Security'),
            meta: {
              title: i18n.t('router.security.title'),
              description: i18n.t('router.security.description'),
              key: 'security'
            }
          },
          {
            path: i18n.t('router.links.loanOriginators'),
            name: 'Loan Originators',
            component: () => import('../views/Loan-originators'),
            meta: {
              title: i18n.t('router.loanOriginators.title'),
              description: i18n.t('router.loanOriginators.description'),
              key: 'loanOriginators'
            }
          },
          {
            path: i18n.t('router.links.joinLoanOriginators'),
            name: 'Join as Loan Originator',
            component: () => import('../views/Join'),
            meta: {
              title: i18n.t('router.joinLoanOriginators.title'),
              description: i18n.t('router.joinLoanOriginators.description'),
              key: 'joinLoanOriginators'
            }
          },
          {
            path: i18n.t('router.links.affiliate'),
            name: 'Affiliate',
            component: () => import('../views/Affiliate'),
            meta: {
              title: i18n.t('router.affiliate.title'),
              description: i18n.t('router.affiliate.description'),
              key: 'affiliate'
            }
          },
          {
            path: i18n.t('router.links.risk'),
            name: 'Risk',
            component: () => import('../views/Risk'),
            meta: {
              title: i18n.t('router.risk.title'),
              description: i18n.t('router.risk.description'),
              key: 'risk'
            }
          },
          {
            path: i18n.t('router.links.team'),
            name: 'Team',
            component: () => import('../views/Team'),
            meta: {
              title: i18n.t('router.team.title'),
              description: i18n.t('router.team.description'),
              key: 'team'
            }
          },
          {
            path: i18n.t('router.links.help'),
            name: 'Help',
            component: () => import('../views/Help'),
            meta: {
              title: i18n.t('router.help.title'),
              description: i18n.t('router.help.description'),
              key: 'help'
            }
          },
          {
            path: i18n.t('router.links.verifyEmail'),
            name: 'Verifying email',
            component: () => import('../views/Verify-Email'),
            meta: {
              title: i18n.t('router.verifyEmail.title'),
              description: i18n.t('router.verifyEmail.description'),
              key: 'verifyEmail'
            }
          },
          {
            path: i18n.t('router.links.feedback'),
            name: 'Feedback',
            component: () => import('../views/Feedback'),
            meta: {
              title: i18n.t('router.feedback.title'),
              description: i18n.t('router.feedback.description'),
              key: 'feedback'
            }
          },
          {
            path: i18n.t('router.links.useragreement'),
            name: 'User Agreement',
            component: () => import('../views/UserAgreement'),
            meta: {
              title: i18n.t('router.useragreement.title'),
              description: i18n.t('router.useragreement.description'),
              key: 'useragreement'
            }
          },
          {
            path: i18n.t('router.links.privacy'),
            name: 'Privacy',
            component: () => import('../views/Privacy'),
            meta: {
              title: i18n.t('router.privacy.title'),
              description: i18n.t('router.privacy.description'),
              key: 'privacy'
            }
          },
          {
            path: i18n.t('router.links.referralProgram'),
            name: 'Referral program',
            component: () => import('../views/Referral-program'),
            meta: {
              title: i18n.t('router.referralProgram.title'),
              description: i18n.t('router.referralProgram.description'),
              key: 'referralProgram'
            }
          },
          {
            path: i18n.t('router.links.statistics'),
            name: 'Statistics',
            component: () => import('../views/Statistics'),
            meta: {
              title: i18n.t('router.statistics.title'),
              description: i18n.t('router.statistics.description'),
              key: 'statistics'
            }
          },
          {
            path: i18n.t('router.links.statisticsOld'),
            name: 'Statistics',
            component: () => import('../views/StatisticsOld'),
            meta: {
              title: i18n.t('router.statistics.title'),
              description: i18n.t('router.statistics.description'),
              key: 'statisticsOld'
            }
          },
          {
            path: i18n.t('router.links.invite'),
            name: 'Invite a friend',
            component: () => import('../views/Referral'),
            meta: {
              title: i18n.t('router.invite.title'),
              description: i18n.t('router.invite.description'),
              key: 'invite'
            }
          }
        ]
    },
    {
      path: '/',
      redirect: '/' + lang + '/'
    }
  ]
} else {
  defaultEngRoutes = [
    {
      path: '/' + lang + '/:catchAll(.*)',
      redirect: '/:catchAll(.*)'
    },
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home'),
      meta:
        {
          title: i18n.t('router.home.title'),
          description: i18n.t('router.home.description')
        }
    },
    {
      path: '/' + i18n.t('router.links.howItWorks'),
      name: 'How it works',
      component: () => import('../views/How-it-works'),
      meta:
        {
          title: i18n.t('router.hiw.title'),
          description: i18n.t('router.hiw.description'),
          key: 'howItWorks'
        }
    },
    {
      path: '/' + i18n.t('router.links.security'),
      name: 'Security',
      component: () => import('../views/Security'),
      meta: {
        title: i18n.t('router.security.title'),
        description: i18n.t('router.security.description'),
        key: 'security'
      }
    },
    {
      path: '/' + i18n.t('router.links.loanOriginators'),
      name: 'Loan Originators',
      component: () => import('../views/Loan-originators'),
      meta: {
        title: i18n.t('router.loanOriginators.title'),
        description: i18n.t('router.loanOriginators.description'),
        key: 'loanOriginators'
      }
    },
    {
      path: '/' + i18n.t('router.links.joinLoanOriginators'),
      name: 'Join as Loan Originator',
      component: () => import('../views/Join'),
      meta: {
        title: i18n.t('router.joinLoanOriginators.title'),
        description: i18n.t('router.joinLoanOriginators.description'),
        key: 'joinLoanOriginators'
      }
    },
    {
      path: '/' + i18n.t('router.links.affiliate'),
      name: 'Affiliate',
      component: () => import('../views/Affiliate'),
      meta: {
        title: i18n.t('router.affiliate.title'),
        description: i18n.t('router.affiliate.description'),
        key: 'affiliate'
      }
    },
    {
      path: '/' + i18n.t('router.links.risk'),
      name: 'Risk',
      component: () => import('../views/Risk'),
      meta: {
        title: i18n.t('router.risk.title'),
        description: i18n.t('router.risk.description'),
        key: 'risk'
      }
    },
    {
      path: '/' + i18n.t('router.links.team'),
      name: 'Team',
      component: () => import('../views/Team'),
      meta: {
        title: i18n.t('router.team.title'),
        description: i18n.t('router.team.description'),
        key: 'team'
      }
    },
    {
      path: '/' + i18n.t('router.links.help'),
      name: 'Help',
      component: () => import('../views/Help'),
      meta: {
        title: i18n.t('router.help.title'),
        description: i18n.t('router.help.description'),
        key: 'help'
      }
    },
    {
      path: '/' + i18n.t('router.links.verifyEmail'),
      name: 'Verifying email',
      component: () => import('../views/Verify-Email'),
      meta: {
        title: i18n.t('router.verifyEmail.title'),
        description: i18n.t('router.verifyEmail.description'),
        key: 'verifyEmail'
      }
    },
    {
      path: '/' + i18n.t('router.links.feedback'),
      name: 'Feedback',
      component: () => import('../views/Feedback'),
      meta: {
        title: i18n.t('router.feedback.title'),
        description: i18n.t('router.feedback.description'),
        key: 'feedback'
      }
    },
    {
      path: '/' + i18n.t('router.links.useragreement'),
      name: 'User Agreement',
      component: () => import('../views/UserAgreement'),
      meta: {
        title: i18n.t('router.useragreement.title'),
        description: i18n.t('router.useragreement.description'),
        key: 'useragreement'
      }
    },
    {
      path: '/' + i18n.t('router.links.privacy'),
      name: 'Privacy',
      component: () => import('../views/Privacy'),
      meta: {
        title: i18n.t('router.privacy.title'),
        description: i18n.t('router.privacy.description'),
        key: 'privacy'
      }
    },
    {
      path: '/' + i18n.t('router.links.referralProgram'),
      name: 'Referral program',
      component: () => import('../views/Referral-program'),
      meta: {
        title: i18n.t('router.referralProgram.title'),
        description: i18n.t('router.referralProgram.description'),
        key: 'referralProgram'
      }
    },
    {
      path: '/' + i18n.t('router.links.statistics'),
      name: 'Statistics',
      component: () => import('../views/Statistics'),
      meta: {
        title: i18n.t('router.statistics.title'),
        description: i18n.t('router.statistics.description'),
        key: 'statistics'
      }
    },
    {
      path: '/' + i18n.t('router.links.statisticsOld'),
      name: 'Statistics',
      component: () => import('../views/StatisticsOld'),
      meta: {
        title: i18n.t('router.statistics.title'),
        description: i18n.t('router.statistics.description'),
        key: 'statisticsOld'
      }
    },
    {
      path: '/' + i18n.t('router.links.invite'),
      name: 'Invite a friend',
      component: () => import('../views/Referral'),
      meta: {
        title: i18n.t('router.invite.title'),
        description: i18n.t('router.invite.description'),
        key: 'invite'
      }
    },
    {
      path: '/contest',
      name: 'Contest',
      component: () => import('../views/Contest'),
      meta: {
        title: 'Contest',
        description: ''
      }
    }
  ]
}

const routes = [...defaultEngRoutes, ...defaultRoutes, ...langRoutes,
  ...[
    {
      path: '/' + lang + '/index.html',
      redirect: '/' + lang + '/'
    },
    {
      path: '/index.html',
      redirect: '/'
    },
    {
      path: '/:catchAll(.*)',
      redirect: '/404'
    }]
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior()
  {
    window.scrollTo(0, 0)
  }
})

Vue.use(VuePageTitle, {router, suffix: ' | ' + process.env.VUE_APP_TITLE})

router.beforeEach((to, from, next) =>
{
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'newPageview'
  })
  // console.log('window.dataLayer pushed newPageview event')
  // Saving UTM tags to Localstorage
  if (to.query)
  {
    const utmTags = {}
    const allowedUtmTags = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'fbclid',
      'gclid',
      'click_id'
    ]
    allowedUtmTags.forEach(function (utmTagName)
    {
      if (to.query[utmTagName])
      {
        utmTags[utmTagName] = to.query[utmTagName]
      }
    })
    if (Object.keys(utmTags).length > 0)
    {
      localStorageHelper.setAsJson('utm_tags', utmTags)
    }

    if (to.query.ref_code)
    {
      localStorageHelper.setAsJson('invitation_code', to.query.ref_code)
    }
  }

  document.documentElement.lang = lang
  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-router-meta-tag]')).map(el => el.parentNode.removeChild(el))
  // Skip rendering meta tags if there are none.
  if (!to.meta)
  {
    return next()
  }

  // Remove link alternate tags to the document head.
  Array.from(document.querySelectorAll('[data-router-alternate-tag]')).map(el => el.parentNode.removeChild(el))
  if (to.meta.key)
  {
    // console.log('Detect to.meta.key:', to.meta.key)

    const locales = ['ee', 'gb']
    const alternateTags = []
    locales.forEach(lc =>
    {
      if (lc !== i18n.locale)
      {
        // console.log('Need to set alternate for locale:', lc, ' : ', i18n.t('router.links.' + to.meta.key, lc))
        const originPath = window.location.origin
        let href = originPath + to.path
          let addLang = 'en'
          switch (lc)
          {
            case 'gb' :
              addLang = 'en'
              break
            case 'ee' :
              addLang = 'et'
              break
          }
          // for def eng version
          if (addLang === 'en') {
            href = originPath + '/' + i18n.t('router.links.' + to.meta.key, lc)
          } else {
            href = originPath + '/' + addLang + '/' + i18n.t('router.links.' + to.meta.key, lc)
          }

        alternateTags.push(
          {
            rel: 'alternate',
            hreflang: addLang,
            href: href
          }
        )
        // console.log(i18n.t('router.links.' + to.meta.key, lc))
      }
    })
    alternateTags.map(tagDef =>
    {
      const tag = document.createElement('link')
      Object.keys(tagDef).forEach(key =>
      {
        tag.setAttribute(key, tagDef[key])
      })
      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-router-alternate-tag', '')
      return tag
    }).forEach(tag => document.head.appendChild(tag)) // Add the link alternate tags to the document head.
    // console.log('Alternate Tags:')
    // console.log(alternateTags)
  }
  const results = []
  if (to.meta.title)
  {
    const title = to.meta.title + ' | ' + process.env.VUE_APP_TITLE
    document.title = title
    results.push({name: 'title', content: title})
    results.push({property: 'og:title', content: title})
    results.push({property: 'twitter:title', content: title})
  }
  if (to.meta.description)
  {
    results.push({
      name: 'description',
      content: to.meta.description,
      id: 'desc'
    })
    results.push({property: 'og:description', content: to.meta.description})
    results.push({property: 'twitter:description', content: to.meta.description})
  }
  results.push({property: 'og:type', content: 'website'})
  results.push({property: 'og:url', content: location.protocol + '//' + location.host + to.path})
  results.push({property: 'og:image', content: location.protocol + '//' + location.host + '/img/income-fb.jpg'})
  results.push({property: 'twitter:image', content: location.protocol + '//' + location.host + '/img/income-fb.jpg'})
  results.push({property: 'og:image:alt', content: 'Income Marketplace logo'})
  results.push({property: 'twitter:card', content: 'summary'})

  // Actual ONLY for test server
  // if (process.env.NODE_ENV === 'development')
  // {
  /*
    results.push(
      {
        name: 'robots',
        content: 'noindex'
      }
    )
  */
  // }

  // Turn the meta tag definitions into actual elements in the head.
  results.map(tagDef =>
  {
    const tag = document.createElement('meta')

    Object.keys(tagDef).forEach(key =>
    {
      tag.setAttribute(key, tagDef[key])
    })

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-router-meta-tag', '')

    return tag
  })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag))

  next()
})

export default router
